/* eslint-disable no-restricted-syntax,no-prototype-builtins */
import api from '../../utils/apiFetch';

const path = 'coupons';

const serialize = (obj) => {
  const str = [];
  for (const p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  return str.join('&');
};

export default {
  getMerchantCouponConfig: () => api.get(`${path}/configs`),
  setMerchantCouponConfig: (payload) => api.post(`${path}/configs`, payload),
  setImageCouponConfig: (payload) => api.file(`${path}/upload-image`, payload),
  getCouponPlanList: (params) =>
    api.get(`${path}/plans-list?${serialize(params)}`),
  getCouponCampaignList: (params) =>
    api.get(`${path}/campaigns?${serialize(params)}`),
  createCouponPlan: (payload) => api.post(`${path}/plan-create`, payload),

  createCouponCampaign: (payload) => api.post(`${path}/campaigns`, payload),
  createSingleCoupon: (payload) => api.post(`${path}/single-coupon`, payload),
  sendSingleCoupon: (payload) =>
    api.post(`${path}/send-single-coupon`, payload),
  deleteCampaignPlan: (id) => api.delete(`${path}/campaign/${id}`),
  deleteCouponPlan: (id) => api.post(`${path}/plan-delete/${id}`),

  getCouponList: (params) => api.get(`${path}/list?${serialize(params)}`),
  getCouponPlans: () => api.get(`${path}/plans`),
  getCouponPlanStoreCreditList: () => api.get(`${path}/store-credits`),
  getCouponDiscountsList: () => api.get(`${path}/discounts`),
  resendEmail: (id) => api.post(`${path}/resend/${id}`),
  cancel: (id) => api.post(`${path}/cancel/${id}`),
  getRedemptions: (params) =>
    api.get(`${path}/redemptions?${serialize(params)}`),
  getMembershipPlanCouponCampaigns: (params) =>
    api.get(`${path}/membership-plan-coupon-campaigns?${serialize(params)}`),
  postMembershipPlanCouponCampaigns: (payload) =>
    api.post(`${path}/membership-plan-coupon-campaigns`, payload),
  getLoyaltyProgramCouponCampaigns: (params) =>
    api.get(`${path}/loyalty-program-coupon-campaigns?${serialize(params)}`),
  postLoyaltyProgramCouponCampaigns: (payload) =>
    api.post(`${path}/loyalty-program-coupon-campaigns`, payload),
  validateCouponCode: (payload) =>
    api.post(`${path}/validate-new-coupon`, payload),
  getReportCouponCampaignsApi: (params) =>
    api.get(`${path}/statistic-coupon-campaign?${serialize(params)}`),
  getCouponCampaignsHistoryApi: (params) =>
    api.get(`${path}/coupon-campaign-history?${serialize(params)}`),
  updatePlanStatusApi: (payload) => api.put(`${path}/plan-status`, payload),
  getVoucherDesigns: () => api.get(`${path}/voucher-designs`),
  saveVoucherDesign: (payload) => api.post(`${path}/voucher-designs`, payload),
  reorderVoucherDesigns: (payload) =>
    api.put(`${path}/voucher-designs/order`, payload),
  updateVoucherDesignStatus: ({ id, status }) =>
    api.put(`${path}/voucher-designs/${id}/status`, { status }),
  deleteVoucherDesign: (id) => api.delete(`${path}/voucher-designs/${id}`),
  getVoucherConfigs: (params) =>
    api.get(`${path}/voucher-configs?${serialize(params)}`),
  saveVoucherConfig: (payload) => api.post(`${path}/voucher-configs`, payload),
  deleteVoucherConfig: (id) => api.delete(`${path}/voucher-configs/${id}`),
  getCouponOrder: (id) => api.get(`${path}/orders/${id}`),
};
